import { Injectable, signal, WritableSignal } from '@angular/core';
import { IUser } from '@models/cms/user';

@Injectable({
	providedIn: 'root',
})
export class UserManagerService {
	user: WritableSignal<IUser | null> = signal(null);

	constructor() {
		this.loadUser();
	}

	/**
	 * Load user - returns mock data since auth is not implemented yet
	 */
	loadUser(forceDownload: boolean = false): void {
		if (this.user() === null || forceDownload) {
			// Return mock user since Rust API requires authentication
			const mockUser: IUser = {
				id: 1,
				username: 'demo',
				email: 'demo@cryptionis.pl',
				phone: null,
				enabled: true,
				invited: [],
				data: {
					defaultInterval: 5,
					reportNotifyTime: null,
				},
			};
			this.user.set(mockUser);
		}
	}
}
